// extracted by mini-css-extract-plugin
module.exports = {"summary":"story-subheadline-module__summary___HiB7","subheadline-color":"story-subheadline-module__subheadline-color__1K2ff"};